import { render, staticRenderFns } from "./preguntasYRespuestas.vue?vue&type=template&id=2d55b242&"
import script from "./preguntasYRespuestas.vue?vue&type=script&lang=js&"
export * from "./preguntasYRespuestas.vue?vue&type=script&lang=js&"
import style0 from "./preguntasYRespuestas.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports